import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./style.css";
import logo from "../../assets/images/logo.png";
import TODIS_SIGN_IN_FORM from "./form";
import TODIS_SIGN_IN_COVER from "./cover";


const SignIn = () => {

    //handling events 



    //components
    return (
        <div className="todis-sign-in-main">
            <Container fluid className="px-lg-5 py-lg-4  p-3">
                <img src="/assets/images/logo.png" width="120" alt="transport community"/>
                <Row className="py-5">
                    
                    <Col xxl={6} xl={12} lg={12} md={12} sm={12}><TODIS_SIGN_IN_COVER /></Col>
                    <Col xxl={6} xl={12} lg={12} md={12} sm={12}><TODIS_SIGN_IN_FORM /></Col>
                </Row>
            </Container>
        </div>
    )

}


export default SignIn;